import React, { useContext, useLayoutEffect, useState } from 'react';
import { FaUserCircle } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { AiOutlinePoweroff } from 'react-icons/ai';
import { IoMdSettings } from 'react-icons/io';

import * as S from './styles';
import NavBarContext from 'context/NavBarContext';
import MyAccountContext from 'context/MyAccountContext';
import { png } from 'utils/imgList';
import { color } from 'styles/pallete';
import { returnRoles } from 'utils/functions';
import { UseTranslationProps } from 'types/UseTranslationProps';
import LogoutModal from 'components/LogoutModal';
import Load from 'components/Load';
import AccordionNavbar from 'components/AccordionNavbar';
import { ItemNav } from 'types/itemNavBar';
import { getObjOnLocalStorage } from 'utils/functions';
import { UserProps } from 'types/UserProps';

export default function Navbar() {
	const userData: UserProps | null = getObjOnLocalStorage();

	const { t }: UseTranslationProps = useTranslation();
	const { isOpen, isReq, listNavBar } = useContext(NavBarContext);
	const { setIsOpen } = useContext(MyAccountContext);

	const [modalLogout, setModalLogout] = useState(false);
	const [dataUser, setDataUser] = useState({ userName: '', imageUser: '' });

	useLayoutEffect(() => {
		setDataUser({
			userName:
				userData !== null && userData.fullName !== null
					? `${userData?.fullName}`
					: 'Desconhecido',
			imageUser: ''
		});
	}, []);

	return (
		<S.containerWithProps isOpenNavBar={isOpen}>
			<S.logoBox>
				<img src={png.logoPreta} alt="logo mobfig" />
			</S.logoBox>

			<S.avatarBox>
				<S.avatarBall onClick={() => setIsOpen((value) => !value)}>
					{typeof dataUser.imageUser !== 'string' ||
					dataUser.imageUser === '' ? (
						<FaUserCircle
							style={{
								color: color.interface.darkgray2,
								fontSize: '60px',
								cursor: 'pointer'
							}}
						/>
					) : (
						<img src={dataUser.imageUser} alt="avatar do usuário" />
					)}
				</S.avatarBall>
				<p>
					{dataUser.userName !== null ||
					dataUser.userName !== undefined ||
					dataUser.userName !== ''
						? dataUser.userName
						: 'Desconhecido'}
				</p>
				<span>
					{t(
						userData !== null && userData?.authentication?.roles.length > 0
							? returnRoles(userData.authentication.roles)
							: 'Tipo desconhecido'
					)}
				</span>
			</S.avatarBox>

			<S.toolsBox>
				<IoMdSettings
					onClick={() => {
						setIsOpen((value) => !value);
					}}
					style={{
						color: color.interface.darkgray2,
						fontSize: '14px',
						cursor: 'pointer'
					}}
				/>
				<AiOutlinePoweroff
					style={{
						color: color.interface.lightBlue2,
						fontSize: '12px',
						cursor: 'pointer'
					}}
					onClick={() => setModalLogout(true)}
				/>
				<LogoutModal open={modalLogout} setOpen={setModalLogout} />
			</S.toolsBox>

			{isReq ? (
				<S.centralizeLoad>
					<Load showText text={t('loadingOptions')} />
				</S.centralizeLoad>
			) : (
				<S.optionsNavBox>
					{listNavBar.map((item: ItemNav) => (
						<AccordionNavbar
							idAccordion={item.id}
							isOpenAccordion={item.isOpen}
							isSubOptions={item.isSubOptions}
							key={item.name}
							arraySubtitles={item.subOptions}
							title={t(item.name)}
							optionIsALink={item.isALink}
							slug={item.slug}
							needTranslationSuboptions
							typeUserArray={item.roleItem}
							pathIconAccordion={item.icon}
							isExternaLink={item.isExternaLink}
							finalDateTagNew={item.finalDateTagNew}
							tagNew={item.tagNew}
						/>
					))}
				</S.optionsNavBox>
			)}
		</S.containerWithProps>
	);
}
